<div class="my-24 flex flex-col gap-24 p-4 md:my-28 md:gap-28">
  <!-- Hero -->
  <app-compare-ionic-appflow-hero-section
    id="hero"
  ></app-compare-ionic-appflow-hero-section>
  <!-- Customer Logos -->
  <app-customer-logo-section id="customers"></app-customer-logo-section>
  <!-- Key Advantages -->
  <app-compare-ionic-appflow-advantages-section
    id="advantages"
  ></app-compare-ionic-appflow-advantages-section>
  <!-- Comparison Table -->
  <app-compare-ionic-appflow-table-section
    id="comparison"
  ></app-compare-ionic-appflow-table-section>
  <!-- Testimonials -->
  <app-testimonials-section id="testimonials"></app-testimonials-section>
  <!-- FAQ -->
  <app-compare-ionic-appflow-faq-section
    id="faq"
  ></app-compare-ionic-appflow-faq-section>
  <!-- CTA -->
  <app-cta-section id="cta"></app-cta-section>
</div>
